// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--border-subtle);
}

/* ── Breadcrumbs ── */
.header__breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family);
  font-size: 0.95rem;
}

.header__breadcrumbs-icon {
  color: var(--text-muted);
}

.breadcrumb__parent {
  color: var(--text-secondary);
  font-weight: 500;
}

.breadcrumb__divider {
  color: var(--text-muted);
}

.breadcrumb__current {
  color: var(--text-primary);
  font-weight: 600;
}

/* ── Header Actions ── */
.header__actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* ── Global Search Bar ── */
.header__search {
  position: relative;
  width: 240px;
}

.header__search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}

.header__search-input {
  width: 100%;
  padding: 10px 14px 10px 40px;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-xl);
  color: var(--text-primary);
  font-size: 0.88rem;
  font-family: var(--font-sans);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.header__search-input:focus {
  border-color: var(--border-active);
  background: var(--bg-glass-hover);
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.1);
  width: 280px; /* Expands smoothly on focus */
  outline: none;
}

/* ── Notification Bell ── */
.header__notification-btn {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.header__notification-btn:hover {
  background: var(--bg-glass-hover);
  color: var(--text-primary);
  border-color: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

.header__notification-badge {
  position: absolute;
  top: 10px;
  right: 11px;
  width: 6px;
  height: 6px;
  background-color: var(--accent-emerald);
  border-radius: 50%;
  box-shadow: 0 0 6px var(--accent-emerald);
  animation: pulse-glow 2s infinite;
}

@keyframes pulse-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  70% {
    transform: scale(1.2);
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,4CAA4C;EAC5C,YAAY,EAAE,8BAA8B;EAC5C,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,sCAAsC;EACtC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;EACA;IACE,qBAAqB;IACrB,2CAA2C;EAC7C;EACA;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;AACF","sourcesContent":[".dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  margin-bottom: 24px;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n/* ── Breadcrumbs ── */\n.header__breadcrumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-family);\n  font-size: 0.95rem;\n}\n\n.header__breadcrumbs-icon {\n  color: var(--text-muted);\n}\n\n.breadcrumb__parent {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.breadcrumb__divider {\n  color: var(--text-muted);\n}\n\n.breadcrumb__current {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* ── Header Actions ── */\n.header__actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* ── Global Search Bar ── */\n.header__search {\n  position: relative;\n  width: 240px;\n}\n\n.header__search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.header__search-input {\n  width: 100%;\n  padding: 10px 14px 10px 40px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-xl);\n  color: var(--text-primary);\n  font-size: 0.88rem;\n  font-family: var(--font-sans);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.header__search-input:focus {\n  border-color: var(--border-active);\n  background: var(--bg-glass-hover);\n  box-shadow: 0 0 12px rgba(16, 185, 129, 0.1);\n  width: 280px; /* Expands smoothly on focus */\n  outline: none;\n}\n\n/* ── Notification Bell ── */\n.header__notification-btn {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.header__notification-btn:hover {\n  background: var(--bg-glass-hover);\n  color: var(--text-primary);\n  border-color: rgba(255, 255, 255, 0.1);\n  transform: scale(1.05);\n}\n\n.header__notification-badge {\n  position: absolute;\n  top: 10px;\n  right: 11px;\n  width: 6px;\n  height: 6px;\n  background-color: var(--accent-emerald);\n  border-radius: 50%;\n  box-shadow: 0 0 6px var(--accent-emerald);\n  animation: pulse-glow 2s infinite;\n}\n\n@keyframes pulse-glow {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);\n  }\n  70% {\n    transform: scale(1.2);\n    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
